import React, { useCallback, useState } from 'react';
import { Container, Box, Snackbar, Typography, Button } from '@mui/material';
import { observer, useLocalObservable } from 'mobx-react-lite';
import { getMaexchenRedeemProductsStructure } from '../csvImport';
import { updateMaexchenProductCatalog } from '../firebaseConnection/database';
import Dropzone from '../hooks/Dropzone';

const MaexchenProductsImportPage = observer((): JSX.Element => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');

  const fileData = useLocalObservable(() => ({
    productCsvData: new File([], ''),
    productVariantCsvData: new File([], ''),
  }));

  const addProductListFile = useCallback(async (acceptedFiles: File[]) => {
    if (acceptedFiles[0]) {
      const [inputFile] = Array.from(acceptedFiles);
      fileData.productCsvData = inputFile;
    }
  }, []);

  const addProductListVariantFile = useCallback(
    async (acceptedFiles: File[]) => {
      if (acceptedFiles[0]) {
        const [inputFile] = Array.from(acceptedFiles);
        fileData.productVariantCsvData = inputFile;
      }
    },
    [],
  );

  const uploadMaexchenProductListData = async () => {
    try {
      if (
        fileData.productCsvData.size > 0 &&
        fileData.productVariantCsvData.size > 0
      ) {
        const maexchenRedeemData = await getMaexchenRedeemProductsStructure(
          fileData.productCsvData,
          fileData.productVariantCsvData,
        );

        await updateMaexchenProductCatalog(maexchenRedeemData);
        setMessage('Success');
        setOpen(true);
      } else {
        setMessage('Productfile or Variantsfile missing');
      }
    } catch (e) {
      setMessage(`Error: ${e}`);
      setOpen(true);
    }
  };

  return (
    <>
      <Container sx={{ width: `calc(100% - ${240}px)`, ml: `${240}px` }}>
        <Box
          component="main"
          sx={{ flexGrow: 1, bgcolor: 'background.default', p: 3 }}
        >
          <Typography variant="h4">Mäxchen Produkte</Typography>
          <Typography variant="subtitle2">Product List File</Typography>
          <Dropzone drop={csvFile => addProductListFile(csvFile)} />
          <Typography variant="subtitle2">Product Variants File</Typography>

          <Dropzone drop={csvFile => addProductListVariantFile(csvFile)} />

          <Typography>
            Product List File: {fileData.productCsvData.name}{' '}
          </Typography>
          <Typography>
            Product Variants File: {fileData.productVariantCsvData.name}{' '}
          </Typography>
          <Button onClick={uploadMaexchenProductListData}>
            Upload Product List
          </Button>
        </Box>

        <Snackbar
          open={open}
          autoHideDuration={6000}
          onClose={() => setOpen(false)}
          message={message}
        />
      </Container>
    </>
  );
});

export default MaexchenProductsImportPage;
